/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum EndorsementSectionEnum {
    ENDORSEMENT_INFORMATION = 1,
    EXPOSURE_AND_PREMIUM = 2,
    BIND_INSTRUCTIONS = 3,
    POLICY_DOCS = 4,
}
